module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nif ((model.teaserList || []).length === 0) {\n%>\t\t<div class=\"noListDataFoundBar\">\nEs wurden leider keine Einträge gefunden, die Ihrem Suchbegriff entsprechen.\n</div>\n<%\t} else {\nfor (var i in (model.teaserList || [])) {\nfor (var j in (model.teaserList[i].components || [])) {\nvar teaserModel = model.teaserList[i].components[j];\nteaserModel.routeID = model.teaserList[i].routeID;\nteaserModel.routePath = model.teaserList[i].path;\nteaserModel.routeName = model.teaserList[i].name;\n%>\t\t\t\t<%- include('./teaser', { model: teaserModel }); %>\n<%\t\t\t}\n}\n}\n%>\n</div>"
  , __filename = "components/templates/news/list/list.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
if ((model.teaserList || []).length === 0) {

    ; __line = 4
    ; __append("		<div class=\"noListDataFoundBar\">\nEs wurden leider keine Einträge gefunden, die Ihrem Suchbegriff entsprechen.\n</div>\n")
    ; __line = 7
    ; 	} else {
for (var i in (model.teaserList || [])) {
for (var j in (model.teaserList[i].components || [])) {
var teaserModel = model.teaserList[i].components[j];
teaserModel.routeID = model.teaserList[i].routeID;
teaserModel.routePath = model.teaserList[i].path;
teaserModel.routeName = model.teaserList[i].name;

    ; __line = 14
    ; __append("				")
    ; __append( include('./teaser', { model: teaserModel }) )
    ; __append("\n")
    ; __line = 15
    ; 			}
}
}

    ; __line = 18
    ; __append("\n</div>")
    ; __line = 19
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/news/list/list.ejs

}